import React, { useCallback } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import './VirtualFixedList.css';

/**
 * Generic fixed-height virtual list for large appointment/history collections.
 */
export default function VirtualFixedList({
  items = [],
  itemHeight,
  itemGap = 0,
  renderItem,
  className = '',
  listClassName = '',
  emptyFallback = null,
  overscanCount = 6,
  ariaLabel,
}) {
  const rowHeight = itemHeight + itemGap;

  const Row = useCallback(
    ({ index, style }) => (
      <div
        className="virtual-fixed-list__row"
        style={{
          ...style,
          height: itemHeight,
          paddingBottom: itemGap,
          boxSizing: 'content-box',
        }}
      >
        {renderItem(items[index], index)}
      </div>
    ),
    [items, itemHeight, itemGap, renderItem]
  );

  if (!items?.length) {
    return emptyFallback;
  }

  return (
    <div
      className={`virtual-fixed-list ${className}`.trim()}
      role="list"
      aria-label={ariaLabel}
    >
      <AutoSizer>
        {({ height, width }) => (
          <FixedSizeList
            className={`virtual-fixed-list__inner ${listClassName}`.trim()}
            height={height}
            width={width}
            itemCount={items.length}
            itemSize={rowHeight}
            overscanCount={overscanCount}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </div>
  );
}
